// extracted by mini-css-extract-plugin
export var attachButton = "_cu-8";
export var sendButton = "_cu-2";
export var sendDisabled = "_cu-4";
export var sendEnabled = "_cu-3";
export var sendIcon = "_cu-6";
export var sendIconDisabled = "_cu-7";
export var sendStreaming = "_cu-5";
export var textarea = "_cu-1";
export var wrapper = "_cu-0";